import { render } from "./LicenseRegistrationComponent.vue?vue&type=template&id=0b733a87"
import script from "./LicenseRegistrationComponent.vue?vue&type=script&lang=js"
export * from "./LicenseRegistrationComponent.vue?vue&type=script&lang=js"

import "./LicenseRegistrationComponent.vue?vue&type=style&index=0&id=0b733a87&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__